<template>
  <div class="ma-2">
    <AtivarRegra v-show="acao.tipo === 'ativarRegra'" :acao="acao" @form="update($event)" @error="error($event)" />
    <DesativarRegra
      v-show="acao.tipo === 'desativarRegra'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
    />
    <LogarAgente v-show="acao.tipo === 'logarAgente'" :acao="acao" @form="update($event)" @error="error($event)" />
    <DeslogarAgente
      v-show="acao.tipo === 'deslogarAgente'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
    />
    <DeslogarDepartamento
      v-show="acao.tipo === 'deslogarDepartamento'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
    />
    <Backup v-show="acao.tipo === 'backup'" :acao="acao" @form="update($event)" @error="error($event)" />
  </div>
</template>

<script>
import AtivarRegra from './AtivarRegra'
import DesativarRegra from './DesativarRegra'
import LogarAgente from './LogarAgente'
import DeslogarAgente from './DeslogarAgente'
import DeslogarDepartamento from './DeslogarDepartamento.vue'
import Backup from './Backup'

export default {
  name: 'Dialog',
  props: {
    acao: Object,
  },
  components: { AtivarRegra, DesativarRegra, LogarAgente, DeslogarAgente, DeslogarDepartamento, Backup },

  data: () => ({
    dialog: true,
    componentKey: 0,
  }),

  methods: {
    update(event) {
      this.$emit('form', event)
    },
    error(error) {
      this.$emit('error', error)
    },
  },
}
</script>
